export const SCALE_NUMBER = 6;
export const SCALE_OFFSET = 50;
export const SCALE_COLOR = '#aaaaaa';

export const CANVAS_WIDTH = window.screen.width > 500 ? 500 : window.screen.width;
export const CANVAS_HEIGHT = 400;

export const CHART_AREA_RECT = { x1: 0, y1: 0, x2: CANVAS_WIDTH, y2: 300 };
export const CHART_PREVIEW_REC = { x1: 0, y1: 350, x2: CANVAS_WIDTH, y2: 400 };
export const SCALE_RECT = { x1: 0, y1: 0, x2: CANVAS_WIDTH, y2: 350 };

export const ANIMATION_STEPS = 40;

let theme = 'day';

export function toggleTheme () {
    theme = theme === 'day' ? 'night' : 'day';
}

export function getTheme () {
    return theme;
}
